BAP_Login = {

    init: function () {

        $('#userAdmin').on('click', function () {
            $('#name').val('admin@remarso.com');
            $('#password').val('admin');
        });
        $('#userCompany1').on('click', function () {
            $('#name').val('norman@remarso.com');
            $('#password').val('admin');
        });
        $('#userCompany2').on('click', function () {
            $('#name').val('wesker@remarso.com');
            $('#password').val('admin');
        });

    }

}

BAP_Login.init();